var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState, } from 'react';
import { createCustomerTransactionAction, useApi, } from '@getclarauk/api-client';
import { defer } from '../util/defer';
import { Spinner } from '../components/Spinner';
export var PomeloPayment = forwardRef(function (_, ref) {
    var createCustomerTransaction = useApi(createCustomerTransactionAction)[0];
    var promiseRef = useRef();
    var transactionIdRef = useRef();
    var _a = useState(), redirectUrl = _a[0], setRedirectUrl = _a[1];
    useImperativeHandle(ref, function () {
        return {
            capture: function (options) {
                return __awaiter(this, void 0, void 0, function () {
                    var transaction, err_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, createCustomerTransaction({
                                        userId: options.userId,
                                        amount: options.amount,
                                        description: options.description,
                                        itemType: options.itemType,
                                        pharmacyId: options.pharmacyId,
                                        cardholderName: options.givenName + ' ' + options.familyName,
                                    })];
                            case 1:
                                transaction = _a.sent();
                                if (!(transaction === null || transaction === void 0 ? void 0 : transaction.session.pomelo)) {
                                    return [2 /*return*/, { error: 'Error' }];
                                }
                                setRedirectUrl(transaction.session.pomelo.redirectUrl);
                                promiseRef.current = defer();
                                transactionIdRef.current = transaction._id;
                                return [2 /*return*/, promiseRef.current.promise];
                            case 2:
                                err_1 = _a.sent();
                                console.log(err_1);
                                return [2 /*return*/, { error: 'Error' }];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            },
        };
    });
    var onMessage = useCallback(function (e) {
        var _a, _b, _c;
        if (((_a = e.data) === null || _a === void 0 ? void 0 : _a.source) !== 'claraACS')
            return;
        if (e.data.status === 'success') {
            (_b = promiseRef.current) === null || _b === void 0 ? void 0 : _b.resolve({
                customerTransactionId: transactionIdRef.current,
            });
        }
        else if (e.data.status === 'error') {
            (_c = promiseRef.current) === null || _c === void 0 ? void 0 : _c.resolve({ error: 'Declined' });
        }
        else {
            return;
        }
        setRedirectUrl(undefined);
    }, []);
    useEffect(function () {
        window.addEventListener('message', onMessage, false);
        return function () {
            window.removeEventListener('message', onMessage, false);
        };
    }, [onMessage]);
    return redirectUrl ? (jsx("iframe", { title: "Pomelo payment", src: redirectUrl, sx: { border: 'none', minHeight: 700 } })) : (jsx("div", { sx: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 700,
        } },
        jsx(Spinner, { size: "xl", sx: { color: 'grey' } })));
});
//# sourceMappingURL=PomeloPayment.js.map